import React from "react";
import { DateTime } from "luxon";

const DateTimeText = (props: any) => {
	return (
		<>
			{DateTime.fromISO(props.utcDateTime, {
				zone: "utc",
			})
				.setZone("Pacific/Auckland")
				.toLocaleString(DateTime.DATETIME_MED)}
			{props.includeRelative && (
				<em>
					<small>
						{" "}
						(
						{DateTime.fromISO(props.utcDateTime, {
							zone: "utc",
						})
							.setZone("Pacific/Auckland")
							.toRelative()}
						)
					</small>
				</em>
			)}
		</>
	);
};
export default DateTimeText;
